document.addEventListener('DOMContentLoaded', function() {
    function toggleSupportItems() {
        const items = document.querySelectorAll('.c_support_item');
        const maxWidth = 750;

        items.forEach((item, index) => {
            if (window.innerWidth <= maxWidth && index >= 4) {
                item.style.display = 'none';
            } else {
                item.style.display = '';
            }
        });
    }

    // 初期表示時に実行
    toggleSupportItems();

    // ウィンドウのサイズが変更されたときに実行
    window.addEventListener('resize', toggleSupportItems);
});